import { Col, Form, Row } from "antd"
import { FormField } from "../../../components/Form/FormField"
import { useTranslation } from "react-i18next"
import { SurveySectionFormData } from "../SurveysViewModel"
import { observer } from "mobx-react"
import { InputType } from "../../../components/TextInput/const/InputType.enum"
import MultimediaUploader from "../../../components/MultimediaUploader/MultimediaUploader"
import { colors } from "../../../assets/styles/appStyles"
import { useState } from "react"
import { UploadFile } from "antd/lib"

interface SurveySectionInformationFormProps {
	formData: SurveySectionFormData
	onChange: (formData: SurveySectionFormData) => void
}
const SectionInformationForm = ({ formData, onChange }: SurveySectionInformationFormProps) => {
	const { t } = useTranslation("surveys", { keyPrefix: "form.sectionInfo" })
	const { t: tForm } = useTranslation("mainForm", { keyPrefix: "validations" })
	const [showImageError, setShowImageError] = useState(false)

	return (
		<>
			<Row gutter={[24, 0]}>
				<Col
					span={24}
					xl={14}
					md={24}
					xs={24}
					style={{ display: "flex", flexDirection: "column" }}
					className="pb-4"
				>
					{formData.id && <FormField.Input key={"id"} label={t("id")} name={"id"} disabled={true} />}
					<FormField.Input
						key={"name"}
						label={t("name")}
						name={"name"}
						mandatory
						placeHolder={t("namePlaceholder")}
						onChange={(name: string) => onChange({ ...formData, name })}
					/>
					<FormField.Input
						key={"name_en"}
						label={`${t("name")} (EN)`}
						name={"name_en"}
						mandatory
						placeHolder={t("namePlaceholderEN")}
						onChange={(name_en: string) => onChange({ ...formData, name_en })}
					/>
					<FormField.Input
						key={"name_ca"}
						label={`${t("name")} (CA)`}
						name={"name_ca"}
						mandatory
						placeHolder={t("namePlaceholderCA")}
						onChange={(name_ca: string) => onChange({ ...formData, name_ca })}
					/>
					<FormField.Input
						key={"description"}
						label={t("description")}
						name={"description"}
						inputType={InputType.TEXTAREA}
						placeHolder={t("descriptionPlaceholder")}
						onChange={(description: string) => onChange({ ...formData, description })}
					/>
					<FormField.Input
						key={"description_en"}
						label={`${t("description")} (EN)`}
						name={"description_en"}
						inputType={InputType.TEXTAREA}
						placeHolder={t("descriptionPlaceholderEN")}
						onChange={(description_en: string) => onChange({ ...formData, description_en })}
					/>
					<FormField.Input
						key={"description_ca"}
						label={`${t("description")} (CA)`}
						name={"description_ca"}
						inputType={InputType.TEXTAREA}
						placeHolder={t("descriptionPlaceholderCA")}
						onChange={(description_ca: string) => onChange({ ...formData, description_ca })}
					/>
					<FormField.Input
						key={"order"}
						label={t("order")}
						name={"order"}
						inputType={InputType.NUMBER}
						placeHolder={t("orderPlaceholder")}
						onChange={(order: string) => onChange({ ...formData, order: parseInt(order) || 0 })}
					/>
				</Col>
				<Col xl={10} md={24} xs={24}>
					<Form.Item
						label={t("image")}
						name={"image"}
						rules={[
							{
								required: true,
								message: tForm("mandatoryField"),
								validator: async (_, value) => {
									setShowImageError(!!!value)
									if (!value) {
										return Promise.reject(tForm("mandatoryField"))
									}
									return Promise.resolve()
								}
							}
						]}
					>
						<MultimediaUploader
							containerStyle={{
								width: "350px",
								height: "350px",
								overflow: "hidden",
								border: `${showImageError ? `1px solid ${colors.error}` : ""}`
							}}
							mediaUrl={formData.image as string & File}
							type="image"
							onClean={() =>
								onChange({
									...formData,
									image: undefined
								})
							}
							manualUpload
							label={t("uploadImage")}
							onChange={(image: UploadFile) => {
								onChange({ ...formData, image })
							}}
							maxDimensions={{ width: 600, height: 300 }}
						/>
					</Form.Item>
				</Col>
			</Row>
		</>
	)
}

export default observer(SectionInformationForm)
